import { ActivatedRoute, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { CommonConstant } from 'src/app/common/utilities/common-constant';


@Injectable({
    providedIn: 'root'
})

export class RouteHandlerService {
    public Route: any = null;
    public NextTaskKey: any = null;
    public ExceptionKeyArr: any[];

    constructor(
        public router: Router,
        private activatedRoute: ActivatedRoute,
        private location: Location
    ) { }

    public NavigateToView(viewKey: any): void {
        this.router.navigate(viewKey);
    }

    public GoBack(): void {
        this.location.back();
    }

    /*** Navigate function with parameter to it to get that param when route hits */
    public NavigateToViewWithQueryParams(viewKey: any, params: any) {
        this.router.navigate(viewKey, { queryParams : params});
    }
}
